import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { Deck } from "@apiserver-rest/ponder-data-client-base";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { getDeckRoute } from "../deck-router";
import { styleDeckElementBackground } from "../deck-utils";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { Subscription } from "rxjs";
import { DeckEditOptionsComponent } from "../deck/tools/deck-edit-options.component";
import { NgClass } from "@angular/common";
import { formatDate } from "@ponder-shared/utils/general";
import { AuthService } from "@ponder-core/auth/auth.service";
import { DeckCopyComponent } from "../deck/tools/deck-copy.component";
import { DeckPreviewGroupComponent } from "./deck-preview-group.component";
import { DeckDeleteComponent } from "../deck/tools/deck-delete.component";
import { NavigationService } from "@ponder-core/navigation/navigation.service";
import { DeckFavoriteComponent } from "../deck/tools/deck-favorite.component";

@Component({
    selector: "deck-preview",
    imports: [DeckEditOptionsComponent, DeckCopyComponent, DeckDeleteComponent, DeckFavoriteComponent, NgClass],
    templateUrl: "./deck-preview.component.html"
})
export class DeckPreviewComponent implements AfterViewInit {
    @Input({ required: true }) public username!: string;
    @Input({ required: true }) public isOwnDecks!: boolean;
    @Input({ required: true }) public deck!: Deck;
    @Input({ required: false }) public groupComponentRef?: DeckPreviewGroupComponent;

    public isVisible: boolean = true;

    @ViewChild("containerOuter") containerOuterRef!: ElementRef<HTMLElement>;
    @ViewChild("containerInner") containerInnerRef!: ElementRef<HTMLElement>;

    public readonly copySvgIcon: string = SvgIconMap.get(SvgIcon.Copy)!;
    public deckUrl!: string;
    public isAuthed: boolean = false;

    private onDeckBackgroundUpdatedSub!: Subscription;

    public constructor(private events: EventBroker, private auth: AuthService, private navigation: NavigationService) {
        this.onDeckBackgroundUpdatedSub = this.events.deck.deckBackgroundUpdatedEvent.subscribe({
            next: (deck: Deck) => {
                if (deck.id === this.deck.id) {
                    this.updateBannerBackground();
                }
            }
        })
    }

    public ngOnInit(): void {
        this.groupComponentRef?.trackPreviewRef(this);
        
        this.deckUrl = getDeckRoute(this.username, this.deck.id);
        this.isAuthed = this.auth.isAuthed();
    }

    public ngOnDestroy(): void {
        this.groupComponentRef?.untrackPreviewRef(this);
        this.onDeckBackgroundUpdatedSub?.unsubscribe();
    }

    public ngAfterViewInit(): void {
        this.updateBannerBackground();
    }

    private updateBannerBackground(): void {
        styleDeckElementBackground(
            this.containerOuterRef.nativeElement, 
            this.containerInnerRef.nativeElement, 
            this.deck.color!, 
            this.deck.backgroundCardId);
    }

    public getUpdatedAt(): string {
        return formatDate(this.deck.updatedAt!);
    }

    public getCreatedAt(): string {
        return formatDate(this.deck.createdAt!);
    }
    
    // -------------------------------------------------------------------------------------
    // Events
    // -------------------------------------------------------------------------------------

    public onDeckClicked(event: Event): boolean {
        event.stopPropagation();
        event.preventDefault();

        this.navigation.goto(this.deckUrl);

        return false;
    }

    public onCopyDeckClicked(): void {
        
    }
}